import { render } from "./z-saving-spinner.vue?vue&type=template&id=59fb454e&scoped=true"
import script from "./z-saving-spinner.vue?vue&type=script&lang=js"
export * from "./z-saving-spinner.vue?vue&type=script&lang=js"

import "./z-saving-spinner.vue?vue&type=style&index=0&id=59fb454e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-59fb454e"

export default script